import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { PersonalVoucherStatus } from "src/common/api/apollo/supplementary";

// ============ INTERFACE ============

export interface PersonalVoucherStateInterface {
  personalVoucher: PersonalVoucherStatus | null;
}

// ============ INIT STATE ============

const initialState: PersonalVoucherStateInterface = {
  personalVoucher: null,
};

// ========= SLICE ==========

export const personalVoucherSlice = createSlice({
  name: 'personalVoucher',
  initialState,
  reducers: {
    setPersonalVoucher: (state: PersonalVoucherStateInterface, action: PayloadAction<PersonalVoucherStatus>) => {
      state.personalVoucher = action.payload;
    },
    resetPersonalVoucher: (state: PersonalVoucherStateInterface) => {
      state.personalVoucher = null;
    },
  }
})

export const { setPersonalVoucher, resetPersonalVoucher } = personalVoucherSlice.actions;

export default personalVoucherSlice.reducer;